document.addEventListener("DOMContentLoaded", function() {
    const moveFieldsMobile = () => {
        const mobileContainer = document.getElementById('p-mobile-area');
        const cv = document.getElementById('p-cv');
        const motivation = document.getElementById('p-motivation');
        const pDocument = document.getElementById('p-document');

        if(window.screen.width <= 1024 && mobileContainer){
            mobileContainer.append(cv);
            mobileContainer.append(motivation);
            mobileContainer.append(pDocument);
        }
    }

    moveFieldsMobile();
    window.addEventListener("resize", () => {
        moveFieldsMobile();
    })
});